import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

// Common country codes
const countryCodes = [
  { code: '+852', name: 'Hong Kong (+852)', nameZh: '香港 (+852)' },
  { code: '+86', name: 'China (+86)', nameZh: '中國 (+86)' },
  { code: '+1', name: 'USA/Canada (+1)', nameZh: '美國/加拿大 (+1)' },
  { code: '+44', name: 'UK (+44)', nameZh: '英國 (+44)' },
  { code: '+65', name: 'Singapore (+65)', nameZh: '新加坡 (+65)' },
  { code: '+81', name: 'Japan (+81)', nameZh: '日本 (+81)' },
  { code: '+82', name: 'South Korea (+82)', nameZh: '韓國 (+82)' },
  { code: '+61', name: 'Australia (+61)', nameZh: '澳洲 (+61)' },
  { code: '+91', name: 'India (+91)', nameZh: '印度 (+91)' },
  { code: '+60', name: 'Malaysia (+60)', nameZh: '馬來西亞 (+60)' },
  { code: '+66', name: 'Thailand (+66)', nameZh: '泰國 (+66)' },
  { code: '+63', name: 'Philippines (+63)', nameZh: '菲律賓 (+63)' }
];

const PhoneNumberInput = ({
  countryCode = '+852',
  phoneNumber = '',
  onCountryCodeChange,
  onPhoneNumberChange,
  error,
  label,
  placeholder,
  className = '',
  required = false
}) => {
  const { currentLanguage, t } = useLanguage();

  // Handle country code change
  const handleCountryCodeChange = (e) => {
    onCountryCodeChange(e.target.value);
  };

  // Handle phone number change
  const handlePhoneNumberChange = (e) => {
    // Only allow digits for phone number
    const sanitizedValue = e.target.value.replace(/\D/g, '');
    onPhoneNumberChange(sanitizedValue);
  };

  // Get display name based on current language
  const getCountryDisplayName = (country) => {
    return currentLanguage === 'zh_HK' ? country.nameZh : country.name;
  };

  const defaultLabel = t('phoneLogin.phoneNumber');
  const defaultPlaceholder = currentLanguage === 'zh_HK'
    ? '請輸入手機號碼'
    : 'Enter phone number';

  return (
    <div className={className}>
      {label !== false && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label || defaultLabel}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="flex space-x-2">
        <div className="w-2/5">
          <select
            value={countryCode}
            onChange={handleCountryCodeChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#075e54] focus:border-[#075e54] text-sm"
            required={required}
          >
            {countryCodes.map((country) => (
              <option key={country.code} value={country.code}>
                {getCountryDisplayName(country)}
              </option>
            ))}
          </select>
        </div>
        <div className="w-3/5">
          <input
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-[#075e54] focus:border-[#075e54] text-sm ${
              error ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder={placeholder || defaultPlaceholder}
            required={required}
          />
        </div>
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      <p className="mt-1 text-xs text-gray-500">
        {currentLanguage === 'zh_HK'
          ? '請輸入不含空格或特殊字符的手機號碼'
          : 'Enter the phone number without spaces or special characters'
        }
      </p>
    </div>
  );
};

export default PhoneNumberInput;
